(() => {
  if (window.JoffzWishlist) return;
  const config = JSON.parse(document.querySelector('[data-wishlist-config]')?.textContent || '{}');
  const strings = config.strings || {};
  const key = 'joffzart:saved-art:v1';
  const valid = item => item && /^[a-z0-9][a-z0-9-]{0,180}$/.test(item.handle);
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? [...new Map(data.filter(valid).map(item => [item.handle, item])).values()].slice(0, 100) : [];
    } catch { return []; }
  };
  let items = read();
  const root = (config.root || '/').replace(/\/?$/, '/');
  const productUrl = item => root + 'products/' + item.handle + (/^\d+$/.test(String(item.variant)) ? '?variant=' + item.variant : '');
  const imageUrl = value => {
    if(typeof value !== 'string' || !value.trim())return ''; 
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : ''; }
    catch { return ''; }
  };
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  const text = key => strings[key] || key;
  let toast;
  let toastTimer;
  const announce = message => {
    toast ||= Object.assign(document.createElement('div'), { className: 'joffz-wish-toast' });
    toast.setAttribute('role', 'status');
    if (!toast.isConnected) document.body.append(toast);
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.hidden = true, 2600);
  };
  const sync = () => {
    const handles = new Set(items.map(item => item.handle));
    document.querySelectorAll('[data-wish-toggle]').forEach(button => {
      const saved = handles.has(button.dataset.handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', text(saved ? 'remove_art' : 'save_art'));
    });
    document.querySelectorAll('.joffz-wishlist-link .wkh-counter').forEach(counter => { const value = items.length ? String(items.length) : ''; if(counter.textContent !== value) counter.textContent = value; });
  };
  const save = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(text('storage_error')); return false; }
    items = next;
    sync();
    return true;
  };
  const decorate = () => {
    document.querySelectorAll('[data-home-original],.joffz-art-pair__media').forEach(media => {
      const link = media.closest('a');
      const card = link?.parentElement;
      if (!card || card.querySelector('[data-wish-toggle]')) return;
      const handle = media.dataset.homeOriginal || new URL(link.href, location.origin).pathname.split('/products/')[1]?.split('/')[0];
      if (!valid({ handle })) return;
      const image = media.querySelector('img');
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'joffz-wish-button'; button.dataset.wishToggle = ''; button.dataset.handle = handle;
      button.dataset.title = image?.alt || handle.replace(/-/g,' '); button.dataset.image = image?.currentSrc || image?.src || ''; button.innerHTML = heart;
      card.classList.add('joffz-wish-host'); card.append(button);
    });
    document.querySelectorAll('.product-card[data-product]').forEach(card => {
      if (card.querySelector('[data-wish-toggle]')) return;
      const handle = card.dataset.product;
      if (!valid({ handle })) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'joffz-wish-button';
      button.dataset.wishToggle = '';
      button.dataset.handle = handle;
      const link = card.querySelector('a[href*="/products/"]');
      button.dataset.title = card.querySelector('.card__heading,.card__title,.card-information__text')?.textContent?.trim() || link?.textContent?.trim() || handle;
      button.dataset.image = card.querySelector('img')?.currentSrc || '';
      button.innerHTML = heart;
      card.classList.add('joffz-wish-host');
      card.append(button);
    });
    sync();
  };
  const money = cents => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.floor(cents / 100));
  let renderVersion = 0;
  const render = async () => {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    const version = ++renderVersion;
    document.querySelector('[data-wishlist-empty]').hidden = items.length > 0;
    grid.replaceChildren();
    const jobs = items.map(item => {
      const card = document.createElement('article');
      card.className = 'joffz-wish-card';
      const link = document.createElement('a');
      link.href = productUrl(item);
      const image = document.createElement('img');
      image.width = 480; image.height = 600; image.alt = item.title || ''; image.loading = 'lazy';
      const source = imageUrl(item.image);
      if (source) image.src = source;
      link.className = 'joffz-wish-visual';
      const piece = document.createElement('span'); piece.className='joffz-wish-piece'; piece.append(image);
      link.append(piece);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'joffz-wish-button'; remove.dataset.wishToggle = ''; remove.dataset.handle = item.handle; remove.innerHTML = heart;
      const title = document.createElement('h3');
      const titleLink = document.createElement('a'); titleLink.href = link.href; titleLink.textContent = item.title || item.handle.replace(/-/g, ' '); title.append(titleLink);
      const price = document.createElement('p');
      price.textContent = text('loading');
      const cta = document.createElement('a'); cta.className = 'joffz-wish-cta'; cta.href = link.href; cta.textContent = text('view_art');
      card.append(link, remove, title, price, cta);
      grid.append(card);
      return async () => {
        try {
          const response = await fetch(root + 'products/' + item.handle + '?view=joffz-saved-art', { credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (version !== renderVersion) return;
          if (!response.ok) { price.textContent = response.status === 404 ? text('unavailable') : text('view_art'); return; }
          const payload = await response.json();
          const product = payload.product;
          if(!product?.variants?.length)throw new Error('Unavailable artwork');
          if (version !== renderVersion) return;
          titleLink.textContent = product.title;
          image.alt = product.title;
          const source = imageUrl(payload.artwork || product.featured_image);
          card.classList.toggle('has-original', !!payload.artwork);
          piece.style.setProperty('--wish-art-ratio',Math.max(.25,Math.min(4,Number(payload.ratio)||.75)));
          image.width=1200;image.height=Math.round(1200/(Number(payload.ratio)||.75));
          if (source) image.src = source;
          const variant = product.variants.find(v => String(v.id) === String(item.variant)) || product.variants.find(v => v.available) || product.variants[0];
          price.textContent = money(variant.price) + (variant.available ? '' : ' · ' + text('unavailable'));
          const target = productUrl({ handle: item.handle, variant: variant.id });
          link.href = target; titleLink.href = target; cta.href = target;
        } catch { if (version === renderVersion) price.textContent = text('view_art'); }
      };
    });
    sync();
    let cursor = 0;
    await Promise.all(Array.from({ length: Math.min(4, jobs.length) }, async () => { while (cursor < jobs.length) await jobs[cursor++](); }));
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wish-toggle]');
    if (!button || !valid({ handle: button.dataset.handle })) return;
    event.preventDefault(); event.stopPropagation();
    const handle = button.dataset.handle;
    const exists = items.some(item => item.handle === handle);
    if (!exists && items.length >= 100) { announce(text('limit')); return; }
    const next = exists ? items.filter(item => item.handle !== handle) : [{ handle, variant: button.dataset.variant || '', title: button.dataset.title || '', image: imageUrl(button.dataset.image || '') }, ...items];
    if (save(next)) { announce(text(exists ? 'removed' : 'saved')); render(); }
  });
  window.addEventListener('storage', event => { if (event.key === key) { items = read(); sync(); render(); } });
  let pending = false;
  new MutationObserver(() => { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; decorate(); }); } }).observe(document.body, { childList: true, subtree: true });
  window.JoffzWishlist = { count: () => items.length };
  decorate(); render();
})();
